
export enum PlanItemKind {
  Sensor = 10,
  SensorFixed = 11,
  Equipment = 20,
  EquipmentMaintenance = 21,
}